export function getAll() {
  return [
    {
      value: 0,
      name: "None",
      text: "無",
    },
    {
      value: 1,
      name: "SalPrice",
      text: "售價",
    },
    {
      value: 2,
      name: "FreePrice",
      text: "折價",
    },
    {
      value: 3,
      name: "Discount",
      text: "折扣",
    },
  ];
}

export function getByName(name) {
  const type = getAll().find(function (item) {
    return item.name.toLowerCase() == name.toLowerCase();
  });
  return type;
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
